export default () => import(/* webpackChunkName: 'coffee/wechat-community/slot-coupon' */ './SlotCoupon');